<template>
  <div :class="{ 'center': true, 'hidden': !showError }">
    <h1>{{$t('linkInvalid')}}</h1>
    <p class="btn-normal-2">
      <router-link :to="{ name: 'Home' }">{{$t('topPage')}}</router-link>
    </p>
  </div>
</template>

<script>
import firebase from 'firebase'

export default {
  name: 'AuthAction',
  data () {
    return {
      auth: firebase.auth(),
      showError: false,
    }
  },
  created () {
    const actionCode = this.$route.query.oobCode
    const continueUrl = this.$route.query.continueUrl
    switch (this.$route.query.mode) {
      case 'resetPassword':
        this.handleResetPassword(this.auth, actionCode)
        break
      case 'recoverEmail':
        this.handleRecoverEmail(this.auth, actionCode)
        break
      case 'verifyEmail':
        this.handleVerifyEmail(this.auth, actionCode, continueUrl)
        break
      default: 
        this.showError = true
    }
  },
  methods: {
    async handleResetPassword (auth, actionCode) {
      await auth.verifyPasswordResetCode(actionCode).then((email) => {
        this.$router.push({ name: 'PasswordReset', query: { email: email, action_code: actionCode } })
      }).catch(() => {
        this.showError = true
      })
    },
    async handleVerifyEmail (auth, actionCode, continueUrl) {
      await auth.applyActionCode(actionCode).then(() => {
        if (continueUrl) {
          window.location.href = continueUrl
        } else {
          this.$router.push({ name: 'Home' })
        }
      }).catch(() => {
        this.showError = true
      })
    },
    async handleRecoverEmail (auth, actionCode) {
      await auth.checkActionCode(actionCode).then(() => {
        return auth.applyActionCode(actionCode)
      }).then(() => {
          this.$router.push({ name: 'AccountEmailRecoveryCompleted' })
      }).catch(() => {
        this.showError = true
      })
    }
  }
}
</script>

<style scoped>
h1 {
  padding: 1rem 1rem;
  font-size: 1.5rem;
  line-height: 2rem;
}
.hidden {
  display: none;
}
</style>
